import { render, staticRenderFns } from "./AddCrowdRule.vue?vue&type=template&id=6c33566a&scoped=true"
import script from "./AddCrowdRule.vue?vue&type=script&lang=js"
export * from "./AddCrowdRule.vue?vue&type=script&lang=js"
import style0 from "./AddCrowdRule.vue?vue&type=style&index=0&id=6c33566a&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c33566a",
  null
  
)

export default component.exports